import { $, addAction, INIT } from '@situation/setdesign.util';

addAction(INIT, () => {
    function toggleState(element) {
        const $element = $(element);
        $element.toggleClass('unselected', $element.val() === '');
    }

    setTimeout(() => {
        $('select')
            .each((_i, el) => toggleState(el))
            .on('change', (event) => toggleState(event.currentTarget));
    }, 250);
});
